import script from "./MemberView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberView.vue?vue&type=script&setup=true&lang=js"

import "./MemberView.vue?vue&type=style&index=0&id=9bd0ee68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd0ee68"]])

export default __exports__